export const getTravelUgInsurance = (state) => state.travelUg;
